import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';

/** One row in the menu. `id` is what `selected` emits. */
export interface BzMenuItem {
  id: string;
  label: string;
  disabled?: boolean;
  /** Draws a separator above this item. */
  dividerBefore?: boolean;
}

/**
 * A dropdown menu, built on `mat-menu`.
 *
 * Material rather than hand-built because a menu is one of the few controls
 * where the keyboard contract is genuinely large: arrow navigation, typeahead,
 * `Home`/`End`, `Escape`, focus restore to the trigger, and correct
 * `role="menu"` / `role="menuitem"` semantics.
 *
 * The trigger is projected, so a caller supplies its own `bz-button` or icon
 * rather than being handed a fixed one.
 */
@Component({
  selector: 'bz-menu',
  imports: [MatMenuModule],
  templateUrl: './bz-menu.html',
  styleUrl: './bz-menu.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BzMenu {
  readonly items = input<readonly BzMenuItem[]>([]);

  /** Accessible name for the trigger when the projected content is icon-only. */
  readonly ariaLabel = input('');

  readonly selected = output<BzMenuItem>();
}
